import { render, staticRenderFns } from "./TagsBox.vue?vue&type=template&id=6fae0d7c&scoped=true&"
import script from "./TagsBox.vue?vue&type=script&lang=js&"
export * from "./TagsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fae0d7c",
  null
  
)

export default component.exports